import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { DefaultButton, IPanelStyles, List, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, IMessageBarProps } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { IField, ITextField } from '../../shared/interfaces';
import AppUtilities from '../../shared/Utilities/appUtilities';
import { RootState } from '../../store';
import RubricaForm from './RubricaForm';

const queryString = require('query-string');
export interface RubricaPanelProps {
    extraCssClass?: string
    rubricaPanelIsOpen: boolean
    onRubricaDismiss: () => void

}

type Props = RubricaPanelProps & RouteComponentProps

const RubricaPanel: React.FunctionComponent<Props> = (props) => {

    let [panelIsOpen, { setTrue: openRubricaPanel, setFalse: dismissRubricaPanel }] = useBoolean(props.rubricaPanelIsOpen);

    let [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    let [errorMessageProps, setErrorMessageProps] = useState<IMessageBarProps>({})

    const rubricaPanelDismiss = () => {


        props.onRubricaDismiss();
    }

    const onRenderFooterContent = () => {
        return (
            <React.Fragment>
                <DefaultButton
                    onClick={rubricaPanelDismiss}
                    text="Chiudi"
                />
            </React.Fragment>
        );
    }

    const onError = (errorMessageProps: IMessageBarProps) => {
        showMessageBar();
        setErrorMessageProps(errorMessageProps)
    }
    return (
        <Panel
            key='rubricaPanel'

            isLightDismiss
            isOpen={panelIsOpen}
            type={PanelType.custom}
            customWidth={'600px'}
            headerText="Rubrica"
            focusTrapZoneProps={{
                isClickableOutsideFocusTrap: true,
                forceFocusInsideTrap: true,
            }}
            onDismiss={rubricaPanelDismiss}
            onRenderFooterContent={onRenderFooterContent}
            // Stretch panel content to fill the available height so the footer is positioned
            // at the bottom of the page
            isFooterAtBottom={false}

        >
            {
                messageBarIsVisible &&
                <MessageBar {...errorMessageProps}
                    onDismiss={dismissMessageBar}
                    dismissButtonAriaLabel="Close" />
            }
            {/*<div className={"flex flex-column position-relative overflow-hidden"}>*/}

            {/*    <ScrollPanel style={{ width: '100%', height: '100%' }} className="custom-scroll-bar">*/}

                    <RubricaForm onError={onError} />


            {/*    </ScrollPanel>*/}
            {/*</div>*/}



        </Panel>

    );
}

export default RubricaPanel;
